// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'swiper/swiper-bundle.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './styles.css';
import './global.css';
import Header from './Header';
import Footer from './Footer';
import LandingPage from './LandingPage';
import About from './About';
import Contact from './Contact';
import Register from './Register';
import Login from './Login';
import Blog from './Blog';
import Verify from './Verify';
import BlogPost from './BlogPost';
import TutorRegistrationForm from './Tutor-Registration';
import AdminDashboard from './AdminDashboard';
import AdminHeader from './AdminHeader';
import AdminUsers from './AdminUsers';
import AdminTutors from './AdminTutors';
import AdminNewsletters from './AdminNewsletters';
import AdminBlog from './AdminBlog';
import AdminWordOfTheDay from './AdminWordOfTheDay';
import AdminLogout from './AdminLogout';
import AdminLogin from './AdminLogin';
import AdminSettings from './AdminSettings';
import PrivateRoute from './PrivateRoute';
import Unsubscribe from './Unsubscribe';

const App = () => {
  React.useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <Router>
      <div className="bg-black text-white">
        <Routes>
          <Route path="/" element={<><Header /><LandingPage /><Footer /></>} />
          <Route path="/about" element={<><Header /><About /><Footer /></>} />
          <Route path="/contact" element={<><Header /><Contact /><Footer /></>} />
          <Route path="/register" element={<><Header /><Register /><Footer /></>} />
          <Route path="/login" element={<><Header /><Login /><Footer /></>} />
          <Route path="/blog" element={<><Header /><Blog /><Footer /></>} />
          <Route path="/verify" element={<><Header /><Verify /><Footer /></>} />
          <Route path="/blog/:id" element={<><Header /><BlogPost /><Footer /></>} />
          <Route path="/tutor-registration" element={<><Header /><TutorRegistrationForm /><Footer /></>} />
          <Route path="/unsubscribe" element={<><Header /><Unsubscribe /><Footer /></>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<PrivateRoute element={<AdminLayout />} />} />
        </Routes>
      </div>
    </Router>
  );
};

const AdminLayout = () => {
  const [showNames, setShowNames] = useState(false);

  return (
    <div className={`admin-pages ${showNames ? 'show-names' : ''}`}>
      <AdminHeader showNames={showNames} setShowNames={setShowNames} />
      <Routes>
        <Route path="/" element={<PrivateRoute element={<AdminDashboard showNames={showNames} />} />} />
        <Route path="users" element={<PrivateRoute element={<AdminUsers showNames={showNames} />} />} />
        <Route path="tutors" element={<PrivateRoute element={<AdminTutors showNames={showNames} />} />} />
        <Route path="newsletter" element={<PrivateRoute element={<AdminNewsletters showNames={showNames} />} />} />
        <Route path="blog" element={<PrivateRoute element={<AdminBlog showNames={showNames} />} />} />
        <Route path="word-of-day" element={<PrivateRoute element={<AdminWordOfTheDay showNames={showNames} />} />} />
        <Route path="logout" element={<PrivateRoute element={<AdminLogout showNames={showNames} />} />} />
        <Route path="settings" element={<PrivateRoute element={<AdminSettings showNames={showNames} />} />} />
        {/* Add other admin routes here */}
      </Routes>
    </div>
  );
};

export default App;